import { SIZE_50 } from '@/lib/gridElements/size';
import { videoViewsTotalTimeConfig } from '@/lib/analytics/kpis/tiktok/videoViewsTotalTimeConfig';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViewsTotalTimeConfig = {
    ...videoViewsTotalTimeConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
